import {
  useAiRecommendationEnabled,
  useCurrentModule,
  useEffectiveRecommendation,
} from '@wix/package-picker-shared-eclipse';
import {
  type AiBannerPlacement,
  getAiBannerPlacement,
} from './getAiBannerPlacement';

export const useAiBannerRowPlacement = (): AiBannerPlacement => {
  const module = useCurrentModule();
  const { isBannerVariant } = useAiRecommendationEnabled();
  const pickId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  const { isAiRecommended } = useEffectiveRecommendation(pickId, false);
  const { data: pick } =
    module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct(
      { productId: pickId },
      Boolean(pickId),
    );

  return getAiBannerPlacement({
    isBannerVariant,
    isAiRecommended,
    hasSale: pick?.hasSale,
  });
};
